var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoteAdd = function SvgNoteAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 28 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h2v-6h6v-2h-6v-6h-2v6H7v2h6zm-9.769 7q-1.381 0-2.306-.925T0 32.769V3.231Q0 1.85.925.925T3.231 0H19l9 9v23.769q0 1.381-.925 2.306T24.769 36zM18 10V2H3.231q-.462 0-.846.385Q2 2.769 2 3.23v29.538q0 .462.385.846.384.385.846.385h21.538q.462 0 .847-.385.384-.384.384-.846V10z"
  })));
};
export default SvgNoteAdd;